import { CreateUserDto } from '../dtos/createUserDto.interface';
import { IPersonalInformationForm } from '../interfaces/personal-information-form.interface';
import { IPersonalInformation } from '../interfaces/personal-information.interface';
import { IRegistration } from '../interfaces/registration.interface';

export class SignupHelper {
    public static preparePersonalInformationFormData(formValue: IPersonalInformationForm): IPersonalInformation {
        return {
            organizationName: formValue.organizationName.trim(),
            firstName: formValue.firstName.trim(),
            lastName: formValue.lastName.trim(),
            locale: formValue.locale['id'],
        };
    }

    public static prepareSignupRequestData(
        personalInformationData: IPersonalInformation,
        registrationData: IRegistration,
    ): CreateUserDto {
        return {
            organizationName: personalInformationData.organizationName.trim(),
            firstName: personalInformationData.firstName,
            lastName: personalInformationData.lastName,
            locale: personalInformationData.locale,
            email: registrationData.email.trim(),
            countryISO31661Alpha2Code: registrationData.country,
            acceptPolicy: registrationData.acceptPolicy,
            subscribeMarketing: registrationData.subscribeMarketing,
        };
    }

    public static prepareSignupRequestDataForQuickSignup(
        locale: string,
        registrationData: IRegistration,
    ): CreateUserDto {
        return {
            organizationName: registrationData.org?.trim() || 'Your Organization',
            firstName: registrationData.firstName.trim() || 'John',
            lastName: registrationData.lastName.trim() || 'Doe',
            locale,
            email: registrationData.email.trim(),
            countryISO31661Alpha2Code: registrationData.country,
            acceptPolicy: registrationData.acceptPolicy,
            subscribeMarketing: registrationData.subscribeMarketing,
        };
    }
}
